'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
export default class FileResultsEmptyText extends PureComponent {
  renderHeader(header) {
    if (!header) {
      return null;
    }

    return /*#__PURE__*/_jsx("div", {
      className: "file-results__empty-text-header is--heading-7",
      children: header
    }, "header");
  }

  renderHelp(help) {
    if (!help) {
      return null;
    }

    return /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: help
    }, "help");
  }

  renderEmptyText({
    header,
    help
  }) {
    return [this.renderHeader(header), this.renderHelp(help)];
  }

  render() {
    const {
      children,
      emptyText
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "file-results__empty-text",
      children: children || this.renderEmptyText(emptyText)
    });
  }

}
FileResultsEmptyText.displayName = 'FileResultsEmptyText';
FileResultsEmptyText.propTypes = {
  children: PropTypes.node,
  emptyText: PropTypes.shape({
    header: PropTypes.node,
    help: PropTypes.node
  })
};
FileResultsEmptyText.defaultProps = {
  emptyText: {}
};